const ITEMS = [
  "CANBERRA",
  "COOMA",
  "BERRIDALE",
  "JINDABYNE",
  "SAME-DAY OR NEXT-DAY",
  "FREE TRACKING & POD",
  "$5 OFF YOUR SECOND ORDER",
  "REFERRAL BONUS AVAILABLE",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden border-y border-[#F0A829]/20 bg-[#0A1A13] py-5"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display px-6 text-xl font-bold uppercase tracking-[0.15em] text-[#F0A829]/70 sm:text-2xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#C8102E]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
